import CourseCard from '../../../components/course-card/CourseCard'
import './allCourseList.scss'

function AllCourseList({ courseList }) {
  // const allCourses = courseList.filter((course) => {
  //   return course.course_status === 'active'
  // })

  return (
    <div className='allCourse-list-wrapper'>
      <p>{courseList.userStatus}</p>
      <div className='allCourse-list'>
        {/* {allCourses.map((course, index) => {
          return <CourseCard course={course} key={index} />
        })} */}
        {courseList.map((course, index) => {
          return <CourseCard course={course} key={index} />
        })}
      </div>
    </div>
  )
}

export default AllCourseList
